// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getCdnDomain() {
    return 'pinkoi.com';
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getS3ObjectUrl(path: string, host: string = 'cdn01') {
    let _host = host;

    if (process.env.NEXT_PUBLIC_MODE === 'production') {
        _host = 'cdn02';
    }

    const cdnHost =
        (process.env.NEXT_PUBLIC_MODE === 'production' ? 'pinzap-' : 'dev-saas-') + _host;

    return 'https://' + cdnHost + '.' + getCdnDomain() + path;
}

export function getStaticImageSource(path: string | undefined | null) {
    if (!path) {
        return {
            source: '',
            srcSet: '',
            src: '',
            type: '',
        };
    }

    const userResolutions =
        typeof window !== 'undefined' && window ? window.devicePixelRatio || 2 : 2;

    const extensionIndex = path.lastIndexOf('.');

    const baseURL = path.substring(0, extensionIndex);

    const extension = path.substring(extensionIndex + 1);

    let src = `${baseURL}.${extension}`;

    const srcSet: string[] = [];

    for (let i = 1; i <= 3; i++) {
        const _src = `${baseURL}@${i}x.${extension}`;

        if (i === userResolutions) {
            src = _src;
        }

        srcSet.push(`${_src} ${i}x`);
    }

    return {
        source: `${baseURL}.${extension}`,
        srcSet: srcSet.join(', '),
        src,
        type: `image/${extension}`,
    };
}

export function getDynamicImageSource(
    path: string | undefined | null,
    width: number = 0,
    height: number = 0
) {
    if (!path) {
        return {
            source: '',
            srcSet: '',
            src: '',
            type: '',
        };
    }

    const userResolutions =
        typeof window !== 'undefined' && window ? window.devicePixelRatio || 2 : 2;

    const extensionIndex = path.lastIndexOf('.');

    const baseURL = path.substring(0, extensionIndex);

    const extension = path.substring(extensionIndex + 1);

    let src = `${baseURL}.${extension}`;

    if (extension === 'mp4') {
        const posterBaseUrl = baseURL
            .replace('video', 'image')
            .replace('display', 'video_preview');

        return {
            source: `${baseURL}.${extension}`,
            srcSet: `${baseURL}_preview.${extension}`,
            src,
            poster: `${posterBaseUrl}_preview_0x0@2x.avif`,
            type: `video/${extension}`,
        };
    }

    const srcSet: string[] = [];

    for (let i = 1; i <= 3; i++) {
        const _src = `${baseURL}_${width}x${height}@${i}x.${extension}`;

        if (i === userResolutions) {
            src = _src;
        }

        srcSet.push(`${_src} ${i}x`);
    }

    return {
        source: `${baseURL}.${extension}`,
        srcSet: srcSet.join(', '),
        src,
        type: `image/${extension}`,
    };
}
